import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';
import {
  actionLoadGridDataRequest,
  actionLoadGridDataSuccess,
  actionLoadGridDataFail,
} from 'react-redux-app/lib/modules/grid/actions';
import { actionAddSiteArticles } from './siteArticle';

import { SITE_ARTICLES_GRID_NAME } from '../constants';
import { SITE_ARTICLES_SCHEMA } from '../schemas';

import { getCurrentSiteId } from '../../site/selectors';

import { removeBlankFields } from 'react-redux-app/lib/modules/core/utils';
import { getGridFilter } from '../utils';


export const actionLoadSiteArticlesRequest = () => (
  (dispatch, getState, { apiClientHelper, history: { location } }) => {
    dispatch(actionLoadGridDataRequest(SITE_ARTICLES_GRID_NAME));

    const filter = getGridFilter(location);

    return apiClientHelper.get(
      '/rest/webmaster/article',
      { params: removeBlankFields({ ...filter, siteId: getCurrentSiteId(getState()) }) },
      SITE_ARTICLES_SCHEMA
    ).then(
      ({ entities, result }) => {
        dispatch(actionAddSiteArticles(entities.siteArticles));

        dispatch(actionLoadGridDataSuccess(
          SITE_ARTICLES_GRID_NAME, result.items, result.count
        ));
      },
      error => {
        dispatch(actionLoadGridDataFail(SITE_ARTICLES_GRID_NAME, error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);
